<template>
  <v-layout row justify-center>
    <v-dialog v-model="isOpen" persistent max-width="32rem">
      <v-card>
        <v-card-text class="body">
          <slot name="body" />
        </v-card-text>
        <v-card-actions class="btn-group">
          <v-btn class="cancel-btn" text outlined depressed @click="emitCancel">{{
            cancelBtnText
          }}</v-btn>
          <v-btn class="ok-btn" :disabled="disableOkButton" depressed @click="emitOk">{{
            okBtnText
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    okBtnText: {
      type: String,
      default() {
        return this.$t('actions.ok');
      },
    },
    cancelBtnText: {
      type: String,
      default() {
        return this.$t('actions.cancel');
      },
    },
    disableOkButton: {
      type: Boolean,
      default: () => false,
    },
  },

  methods: {
    emitOk() {
      this.$emit('onOk');
    },

    emitCancel() {
      this.$emit('onCancel');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.v-card {
  .body.v-card__text {
    font-size: 1.5rem;
    font-weight: bold;
    text-align: center;
    color: $pricing-black;
    padding-top: 4rem;
  }

  .btn-group.v-card__actions {
    justify-content: center;
    padding: 0 0 3rem;

    .cancel-btn {
      color: $btn-ok-color;
      border-color: $btn-ok-color;
      letter-spacing: normal;
    }

    .ok-btn {
      color: $pricing-white;
      background-color: $btn-ok-color;
      border-color: $btn-ok-color;
      letter-spacing: normal;
    }
  }
}

.v-btn {
  font-size: 1.2rem;
}
</style>
